import { Button, Flex, Input, Skeleton } from "antd";
import ReusableTable from "../../Reuseable/ReusableTable/ReusableTable";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchFieldAgentDetails, fetchTelecallerFieldAgents } from "../../store/telecaller/cases";
import { useParams } from "react-router-dom";


const ViewAgentDetails = () => {
    const { field_agent_details, field_agent_details_loading } = useSelector(state => state.telecallerCases)
    const dispatch = useDispatch();
    const { id } = useParams();
    const [params, setParams] = useState({
        search: ''
    })

    useEffect(() => {
        dispatch(fetchFieldAgentDetails({ id, query: params }))
    }, [dispatch,params])
    const handleViewClick = () => {

    }
    const column = [
        {
            title: 'Customer Name',
            dataIndex: 'customer_name',
            key: 'customer_name',
            render: (text) => field_agent_details_loading ? <Skeleton.Input size="small" active /> : text || 'NA'

        },
        {
            title: 'Loan No',
            dataIndex: 'loan_no',
            key: 'loan_no',
            render: (text) => field_agent_details_loading ? <Skeleton.Input size="small" active /> : text || 'NA'

        },
        {
            title: 'Phone No',
            dataIndex: 'role',
            key: 'role',
            render: (text) => field_agent_details_loading ? <Skeleton.Input size="small" active /> : text || 'NA'

        },
        {
            title: 'Bucket',
            dataIndex: 'bucket',
            key: 'bucket',
            render: (text) => field_agent_details_loading ? <Skeleton.Input size="small" active /> : text || 'NA'

        },
        {
            title: 'Amount Overdue',
            dataIndex: 'full_name',
            key: 'full_name',
            render: (text) => field_agent_details_loading ? <Skeleton.Input size="small" active /> : text || 'NA'


        },
        {
            title: 'Bank',
            dataIndex: 'bank',
            key: 'bank',
            render: (text) => field_agent_details_loading ? <Skeleton.Input size="small" active /> : text || 'NA'

        },
        {
            title: 'Actions',
            dataIndex: 'allocated_count',
            key: 'allocated_count',
            render: (text, record) => field_agent_details_loading ? <Skeleton.Input size="small" active /> : <Button
                type="default"
                danger
                className="viewBtn"
                size="small"
                style={{ display: 'flex', alignItems: 'center', height: '30px', padding: '0px 10px' }}
                onClick={() => handleViewClick(record)}
            >
                Give Feedback
            </Button>
        },




    ]

    return (

        <div className="allocationPage">
            <Flex justify="space-between" align="center" className="allocationHeader">
                <Flex className="headerLeft">
                    {true && (
                        <Input
                            placeholder="Search"
                            allowClear
                            className="searchInput"
                        
                        //   onChange={(e) => setSearchInput(e.target.value)}
                          onPressEnter={(e) => {
                            const value = e.target.value;
                            setParams((prev) => ({
                              ...prev,
                                search: value,
                            }));
                          }}
                        />
                    )}

                </Flex>
            </Flex>
            <ReusableTable
                columns={column}
                dataSource={field_agent_details_loading ? Array(5).fill({}) : field_agent_details?.data}
            // columns={
            //   selectedTab === "Unallocated" ? unallocatedColumns : allocatedColumns
            // }
            // dataSource={
            //   loading
            //     ? Array(5)
            //       .fill(0)
            //       .map((_, i) => ({ id: `skeleton-${i}` }))
            //     : selectedTab === "Unallocated"
            //       ? unAllocatedCasesData
            //       : allocatedCasesData
            // }
            // totalItems={
            //   selectedTab === "Unallocated" ? unAllocatedCount : allocatedCount
            // }
            // rowKey="id"
            // rowSelection={customRowSelection}
            // onRowClick={onRowClick}
            // pointer={pointer}
            // CurrentPageNo={currentPage}
            // pageSize={pageSize}
            // triggerChange={(page, size) => {
            //   onPaginationChange(page, size);
            //   setCurrentPage(page);
            //   setPageSize(size);
            // }}
            />
        </div>
    );
};

export default ViewAgentDetails;
